import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
interface AccordionItemProps {
  question: string;
  answer: string;
}
export function AccordionItem({
  question,
  answer
}: AccordionItemProps) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-gray-200 last:border-0" data-id="element-1">
      <button className="flex w-full items-center justify-between py-6 text-left focus:outline-none" onClick={() => setIsOpen(!isOpen)} aria-expanded={isOpen} data-id="element-2">
        <span className="text-lg font-medium text-[#1F2937] font-serif" data-id="element-3">
          {question}
        </span>
        {isOpen ? <ChevronUp className="h-5 w-5 text-blue-600 flex-shrink-0 ml-4" data-id="element-4" /> : <ChevronDown className="h-5 w-5 text-gray-400 flex-shrink-0 ml-4" data-id="element-5" />}
      </button>
      <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-96 opacity-100 pb-6' : 'max-h-0 opacity-0'}`} data-id="element-6">
        <p className="text-gray-600 leading-relaxed" data-id="element-7">{answer}</p>
      </div>
    </div>;
}
export function Accordion({
  children
}: {
  children: React.ReactNode;
}) {
  return <div className="divide-y divide-gray-200 border-t border-b border-gray-200" data-id="element-8">
      {children}
    </div>;
}